import { useCallback, useEffect } from "react";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { paymentScreens } from "./paymentScreens";

export function useSetCurrentPaymentScreen() {
  const { state, dispatch } = usePaymentPage();

  const { isManagingPaymentMethods, isModifyingScheduledPayment } =
    state.screenControlFlags;

  const setScreen = useCallback(
    (screen) => {
      dispatch({
        type: "setCurrentScreen",
        screen,
      });
    },
    [dispatch]
  );

  useEffect(() => {
    // ##########################################
    // SUCCESS SCREEN
    // ##########################################
    const setToSuccessScreen = checkSuccessScreenMatch({
      modifyPayment: state.modifyPayment,
      pollingPaymentResponse: state.pollingPaymentResponse,
      recurringPaymentsOnlySuccess: state.recurringPaymentsOnlySuccess,
    });
    if (setToSuccessScreen) return setScreen(paymentScreens.success);

    // ##########################################
    // MODIFY OR CANCEL SCREEN
    // ##########################################
    const setToModifyOrCancel = checkModifyOrCancelScreenMatch({
      modifyPayment: state.modifyPayment,
      pollingPaymentResponse: state.pollingPaymentResponse,
      isModifyingScheduledPayment,
    });
    if (setToModifyOrCancel) return setScreen(paymentScreens.modifyOrCancel);

    // ##########################################
    // MANAGE PAYMENT METHODS SCREEN
    // ##########################################
    const setToManagePaymentMethodsScreen =
      checkManagePaymentMethodsScreenMatch({ isManagingPaymentMethods });
    if (setToManagePaymentMethodsScreen)
      return setScreen(paymentScreens.managePaymentMethods);

    // ##########################################
    // PAYMENT FORM
    // ##########################################
    // the paymentForm screen is the default
    // (but only set once initial data has loaded, which we check via presence of state.fund.ID)
    if (state.fund.ID) {
      setScreen(paymentScreens.paymentForm);
    }
  }, [
    dispatch,
    isManagingPaymentMethods,
    isModifyingScheduledPayment,
    setScreen,
    state.modifyPayment,
    state.pollingPaymentResponse,
    state.fund.ID,
    state.recurringPaymentsOnlySuccess,
  ]);
}

const logRoutingDetails = false;

function handleLogging(screen, isMatch, args) {
  if (process.env.NODE_ENV !== "development" || !logRoutingDetails) return;

  const screenNamePlusMatch = `${screen} :: ${
    isMatch ? "✅ MATCH" : "🚫 No match"
  }`;

  console.groupCollapsed(screenNamePlusMatch);
  console.log(args);
  console.groupEnd();
}

function checkModifyOrCancelScreenMatch({
  modifyPayment,
  // pollingPaymentResponse,
  isModifyingScheduledPayment,
}) {
  const isMatch =
    modifyPayment?.paymentID &&
    !isModifyingScheduledPayment &&
    !modifyPayment?.paymentAlreadyCompleted;
  // && !pollingPaymentResponse?.paymentStatus === "success";
  handleLogging("cancelOrModify screen", isMatch, { ...arguments[0] });

  return isMatch;
}

function checkManagePaymentMethodsScreenMatch({ isManagingPaymentMethods }) {
  const isMatch = isManagingPaymentMethods;
  handleLogging("manage payment methods screen", isMatch, { ...arguments[0] });

  return isMatch;
}

export function checkSuccessScreenMatch({
  modifyPayment,
  pollingPaymentResponse,
  recurringPaymentsOnlySuccess,
}) {
  const modifyPaymentAlreadyCompleted = modifyPayment?.paymentAlreadyCompleted;
  const paymentSuccessful =
    pollingPaymentResponse?.paymentStatus === "completed";
  const paymentResponseTimedOut =
    pollingPaymentResponse?.paymentStatus === "responseTimedOut";

  const isMatch =
    paymentSuccessful ||
    paymentResponseTimedOut ||
    modifyPaymentAlreadyCompleted ||
    recurringPaymentsOnlySuccess;

  handleLogging("success screen", isMatch, { ...arguments[0] });

  return isMatch;
}
